import { render, staticRenderFns } from "./InteractiveImage_Label_Edit.vue?vue&type=template&id=5939f858&"
import script from "./InteractiveImage_Label_Edit.vue?vue&type=script&lang=js&"
export * from "./InteractiveImage_Label_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports